import { __rest } from "tslib";
import React, { forwardRef } from "react";
import { useWindowSize } from "../../shared/hooks";
import { breakpoints } from "../../shared/constants";
import { MobileMenu } from "./MobileMenu";
import { DesktopMenu } from "./DesktopMenu";
import { productLinks } from "./productLinks";
import * as S from "./styles";
export var SEOHiddenLinks = function SEOHiddenLinks() {
  return React.createElement(S.HiddenWrapper, null, productLinks.map(function (e) {
    return React.createElement("a", {
      href: e.url,
      tabIndex: -1,
      key: e.label
    }, e.label);
  }));
};
export var Header = forwardRef(function (e, n) {
  var o = e.loggedIn,
      t = e.logoSrc,
      r = e.logoAlt,
      a = e.className,
      l = e.cartComponent,
      s = e.accountLinks,
      c = e.onMenuOpen,
      u = e.onMenuClose,
      i = e.onSubMenuOpen,
      p = e.onSubMenuClose,
      m = __rest(e, ["loggedIn", "logoSrc", "logoAlt", "className", "cartComponent", "accountLinks", "onMenuOpen", "onMenuClose", "onSubMenuOpen", "onSubMenuClose"]),
      d = useWindowSize(),
      M = !!d.width && d.width < breakpoints.forTabletHorizontalUp;

  return React.createElement(S.HeaderWrapper, Object.assign({
    className: a,
    ref: n
  }, m), React.createElement(S.Header, null, M && React.createElement(MobileMenu, {
    loggedIn: o,
    accountLinks: s
  }), React.createElement(S.LogoLink, {
    href: "/"
  }, React.createElement("img", {
    src: t,
    alt: r
  })), !M && React.createElement(DesktopMenu, {
    loggedIn: o,
    accountLinks: s,
    onMenuOpen: c,
    onMenuClose: u,
    onSubMenuOpen: i,
    onSubMenuClose: p
  }), l), React.createElement(SEOHiddenLinks, null));
});
export default Header;